/**
 * API请求工具
 * 根据环境自动选择正确的API基础URL
 */

// 获取API基础URL
const getBaseUrl = () => {
  // 在开发环境中
  if (process.env.NODE_ENV === 'development') {
    // 直接返回后端地址
    return 'http://127.0.0.1:8080';
  }
  
  // 在生产环境中，使用相对路径
  // 因为在生产环境中，前端和后端由同一个服务器提供服务
  return '';
};

// API基础URL
const API_BASE_URL = getBaseUrl();

/**
 * 通用API请求函数
 * @param {string} endpoint - API端点路径，如 '/api/users'
 * @param {Object} options - fetch选项
 * @returns {Promise} - fetch请求的Promise
 */
export const fetchApi = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  // 默认选项
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  
  // 合并选项
  const fetchOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };
  
  try {
    const response = await fetch(url, fetchOptions);
    
    // 获取响应JSON
    const data = await response.json();
    
    // 检查响应状态和API返回的success字段
    if (!response.ok) {
      // 如果响应状态不是2xx，返回API的错误信息
      // 这样调用方可以直接访问错误信息而不用处理异常
      return data;
    }
    
    return data;
  } catch (error) {
    console.error(`API请求错误 (${endpoint}):`, error);
    throw error;
  }
};

// 特定API端点的封装
export const apiService = {
  // 获取热门文章
  getHottestArticles: () => fetchApi('/api/hottest_article'),
  
  // 获取开发案例
  getDevCases: () => fetchApi('/api/dev_cases'),
  

  // 获取商品计划目录
  getWechatPlans: () => fetchApi('/api/wechat/plans'),
  
  // 创建微信支付订单
  createWechatOrder: (data) => fetchApi('/api/wechat/order/create', {
    method: 'POST',
    body: JSON.stringify(data),
  }),
  
  // 查询微信支付订单状态
  queryWechatOrder: (orderId) => fetchApi(`/api/wechat/order/query?order_id=${encodeURIComponent(orderId)}`),

  // 汇率监控相关API
  // 获取当前汇率数据
  getExchangeRates: () => fetchApi('/api/exchange-rates'),

  // 获取支持的汇率对列表
  getCurrencyPairs: () => fetchApi('/api/exchange-rates/currency-pairs'),

  // 创建汇率订阅
  createExchangeSubscription: (data) => fetchApi('/api/exchange-subscriptions', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  // 获取总订阅数（包括活跃和已触发的订阅）
  getSubscriptionCount: () => fetchApi('/api/exchange-subscriptions/count'),

  // 获取活跃订阅数（仅统计未触发的订阅）
  getActiveSubscriptionCount: () => fetchApi('/api/exchange-subscriptions/active-count'),

  // 获取成功提醒总数
  getSuccessfulAlertsCount: () => fetchApi('/api/exchange-alerts/count'),

};

export default apiService; 